import { useGetRequest } from 'hooks/utils/useGetRequest';
import { CreatedInterfaces } from 'interfaces';

// TODO: type return
const useGetCardProducts = (pageIndex: number, pageSize: number): any => {
  const resource = 'card-products';

  const path = `v1/card_products?size=${pageSize}&page=${pageIndex}`;

  const [{ data, error, loading }] = useGetRequest<CreatedInterfaces<typeof resource>>({ path });

  return {
    cardProducts: data?.data?.sort(),
    pageInfo: {
      ...data?.pagination,
      total: (data?.pagination?.size ?? 0) * (data?.pagination?.total ?? 0),
    },
    isLoading: loading,
    isError: error,
  };
};

export default useGetCardProducts;
